import React from 'react';

import { Container } from './styles';

const PlaceInfo: React.FC = () => {
  return (
    <Container>
      <h1>PlaceInfo</h1>
    </Container>
  );
};

export default PlaceInfo;
